<script>
import { serverBus } from "../../main";
import GAuth from "vue-google-oauth2";
import Vue from "vue";
import Icono from "../Icono/Icono";
import Notificaciones from "../Notificaciones/Notificaciones";
import firebase from "firebase";

let clientID = "131164097423-6e6bvj6dho4ocg69hso5tp8ng3ph0s0b.apps.googleusercontent.com";
let scope = "profile email https://www.googleapis.com/auth/plus.logout";
Vue.use(GAuth, { clientId: clientID, scope: scope });
export default {
  data() {
    return {
      mostrarNombre:false,
      showMenu: false,
      imageProfile: "",
      calendar: "https://google.com/calendar",
      iconoCalendario: "M43,3.5h-3.7V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v7c0,0.6,0.4,1,1,1s1-0.4,1-1V5.5H42v7.3H2V5.5h2.7V8c0,0.6,0.4,1,1,1s1-0.4,1-1 V1c0-0.6-0.4-1-1-1s-1,0.4-1,1v2.5H1c-0.6,0-1,0.4-1,1V43c0,0.6,0.4,1,1,1h42c0.6,0,1-0.4,1-1V4.5C44,3.9,43.6,3.5,43,3.5z M2,42 V14.8h40V42H2z M9.3,8V1c0-0.6,0.4-1,1-1s1,0.4,1,1v2.5h21.3V1c0-0.6,0.4-1,1-1s1,0.4,1,1v7c0,0.6-0.4,1-1,1s-1-0.4-1-1V5.5H11.3V8 c0,0.6-0.4,1-1,1S9.3,8.6,9.3,8z M23.2,17.5c-0.5,0-1,0.1-1.5,0.4c0,0-0.1,0-4.9,2.8c-1.6,0.9-2.1,3-1.2,4.6c0.4,0.8,1.2,1.3,2,1.5 c0.8,0.2,1.6,0.1,2.3-0.2V36c0,1.8,1.5,3.3,3.3,3.3s3.3-1.5,3.3-3.3V20.8C26.5,19,25,17.5,23.2,17.5z M24.5,36 c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3V24.9c0-0.4-0.2-0.7-0.5-0.9c-0.2-0.1-0.3-0.1-0.5-0.1s-0.3,0-0.5,0.1l-1.3,0.7 c-0.6,0.4-1.4,0.1-1.8-0.5c-0.4-0.6-0.1-1.5,0.5-1.8c0,0,4.7-2.7,4.8-2.8c0.9-0.5,1.9,0.3,1.9,1.2V36z",
      iconoCerrarSesion: "M43.7,22.7l-10,10C33.5,32.9,33.3,33,33,33s-0.5-0.1-0.7-0.3c-0.4-0.4-0.4-1,0-1.4l8.3-8.3H16c-0.6,0-1-0.4-1-1s0.4-1,1-1h24.6l-8.3-8.3c-0.4-0.4-0.4-1,0-1.4s1-0.4,1.4,0l10,10c0.1,0.1,0.2,0.2,0.2,0.3c0.1,0.2,0.1,0.5,0,0.8C43.9,22.5,43.8,22.6,43.7,22.7z M28,36c-0.6,0-1,0.4-1,1v5H2V2h25v5c0,0.6,0.4,1,1,1s1-0.4,1-1V1c0-0.6-0.4-1-1-1H1C0.4,0,0,0.4,0,1v42c0,0.6,0.4,1,1,1h27c0.6,0,1-0.4,1-1v-6C29,36.4,28.6,36,28,36z"
    };
  },
  components: {
    Icono,
    Notificaciones
  },
  computed: {
    userName: function() {
      return this.$store.state.user;
    },
    userImage: function() {
      return this.$store.state.gmailUserImage;
    }
  },
  created() {},
  methods: {
    abrirCalendario(){
      let routeData = this.$router.resolve({name: 'calendario'})
      window.open(routeData.href, '_blank')
    },
    displayCalendar: function() {
      window.open(this.calendar);
    },
    logout(ev) {
      firebase.auth().signOut();
      this.$store.dispatch("saveUser", "");
      this.$store.dispatch("saveEmail", "");
      this.$store.dispatch("saveUserImage", "");
      window.location.replace("/#/");
    }
  }
};
</script>
<template src="./HeaderNav.html"></template>
<style lang="scss" src="./HeaderNav.scss"></style>



// WEBPACK FOOTER //
// src/components/HeaderNav/HeaderNav.vue